import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

// The backend has a single canonical clock (config.time_zone / APP_TIME_ZONE,
// currently Europe/Moscow / +03:00). Every date/time field the API exchanges —
// seconds_start, "today", availability — is in this zone, NOT the browser's.
// Moscow has no DST so it is a fixed +03:00, but using the IANA name keeps this
// correct if the backend's APP_TIME_ZONE is ever changed.
export const APP_TIME_ZONE = "Europe/Moscow";

// "Now" expressed in the application timezone, independent of where the browser
// physically is. Returns a dayjs object already pinned to APP_TIME_ZONE, so
// .hour()/.minute()/.format()/.startOf("day") all read as app-tz wall-clock.
export function appNow() {
  return dayjs().tz(APP_TIME_ZONE);
}

// Start of the current app-tz day (midnight in APP_TIME_ZONE).
export function appStartOfToday() {
  return appNow().startOf("day");
}
